import { Flex, Paper, Text, Title } from "@mantine/core";
import { IconShield, IconFileText, IconLock } from "@tabler/icons-react";
import { squareIcon } from "./PricingStyles";

export default function IncludedFeaturesSection() {
  const features = [
    [IconShield, "var(--mantine-color-primary-6)", "var(--mantine-color-primary-0)", "Legal Protection"],
    [IconFileText, "var(--mantine-color-green-7)", "var(--mantine-color-green-0)", "Document Management"],
    [IconLock, "var(--mantine-color-violet-7)", "var(--mantine-color-violet-0)", "Security & Compliance"],
    // [IconUsers, "var(--mantine-color-orange-7)", "var(--mantine-color-orange-0)", "Team Collaboration"],
    // [IconSparkles, "var(--mantine-color-red-7)", "var(--mantine-color-red-0)", "Project Management"],
    // [IconFileText, "var(--mantine-color-primary-6)", "var(--mantine-color-primary-0)", "Activity Tracking"],
  ] as const;

  return (
    <Flex direction="column" align="center" py={60} px="xl" maw={1200} mx="auto">
      <Title order={2} mb="xs" ta="center">
        What's Included in the Workspace
      </Title>
      <Text c="slate.6" mb="xl" ta="center">
        Everything you need for secure, structured collaboration
      </Text>

      <Flex gap={60} justify="center" wrap="wrap" w="100%">
        {features.map(([Icon, color, bg, title]) => (
          <Paper
            key={title as string}
            p="xl"
            radius="lg"
            w={{ base: "100%", xs: "calc(50% - 30px)", sm: "calc(33.333% - 40px)" }}
            style={{ border: "1px solid var(--mantine-color-gray-2)", textAlign: "left" }}
          >
            <Icon size={20} color={color as string} style={squareIcon(bg as string)} />

            <Text fw={600} mb="xs">
              {title}
            </Text>

            <Text size="sm" c="slate.6">
              {title === "Legal Protection" &&
                "Auto-generated mutual NDA signed by both parties before workspace access."}

              {title === "Document Management" && "Secure file sharing with version control and organized folders."}

              {title === "Security & Compliance" && "End-to-end encryption, audit logs, access controls."}

              {/* {title === "Team Collaboration" && "Invite team members, assign roles, manage permissions."}

              {title === "Project Management" && "Task lists, milestones, and progress tracking."}

              {title === "Activity Tracking" && "Complete audit trail of all actions and communications."} */}
            </Text>
          </Paper>
        ))}
      </Flex>
    </Flex>
  );
}
